import React from "react";
import classnames from "classnames";
import { VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import { setIsHistoryShopsModalOpened, store, setIsLoading } from "../store";
import { store as dataStore } from "@components/VerticalLayout/store";

import ErrorToast from "@components/Common/ErrorTost";
import { ArchivedValidationModal } from "@components/Common/ArchivedValidationModal";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { generalConfigStore } from "@store";
import {
    checkIfSaleSupportIsArchived,
    getArrayOfRows,
    handleArchivePaymentMethod,
    shouldDisableAction,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type CustomSideFilterType = {
    isShopSelected: boolean;
    selectedRows: any;
    isAssociateModalOpened: boolean;
    setIsAssociateModalOpened: Function;
    setLocalFilterActive: Function;
    isArchivedPaymentMethodsClicked: boolean;
    setIsArchivedPaymentMethodsClicked: Function;
};

export function CustomSideFilter({
    isShopSelected,
    selectedRows,
    isAssociateModalOpened,
    setIsAssociateModalOpened,
    setLocalFilterActive,
    isArchivedPaymentMethodsClicked,
    setIsArchivedPaymentMethodsClicked,
}: CustomSideFilterType) {
    const { t } = useTranslation();
    const {
        shopsNumberActive,
        shopsNumberArchived,
        isHistoryShopsModalOpened,
        listFranchiseArchived,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const { userID, franchiseID, operatorID } = useSnapshot(dataStore);
    const { fetchGlobal } = useFetchGlobal();
    const [
        isArchivedValidationModalOpened,
        setIsArchivedValidationModalOpened,
    ] = React.useState<boolean>(false);
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [isActive, setIsActive] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    React.useEffect(() => {
        if (isValidateClicked) {
            handleArchivePaymentMethod(
                itemsDisable,
                { userID, franchiseID, operatorID },
                isActive,
                selectedRows,
                setIsValidateClicked,
                fetchGlobal
            );
            setIsArchivedValidationModalOpened(false);
        }
        // eslint-disable-next-line
    }, [isValidateClicked, isActive]);

    return (
        <div className="d-flex justify-content-start align-items-center">
            {modify === true ? (
                <>
                    <CustomMainColorButton
                        className="w-100 ml-2 mdr_btn_BTassignPaymentMethod"
                        disabled={
                            isShopSelected && !isArchivedPaymentMethodsClicked
                                ? false
                                : true
                        }
                        rounded
                        variant="primary"
                        onClick={() => {
                            setLocalFilterActive(false);
                            setIsAssociateModalOpened(!isAssociateModalOpened);
                        }}
                    >
                        {t("Assign payment method")}
                    </CustomMainColorButton>
                </>
            ) : null}
            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_BTmenu"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_BTlistActivated"
                    )}
                    onClick={() => {
                        setIsArchivedPaymentMethodsClicked(false);
                    }}
                >
                    {t("Enabled payment methods")}({shopsNumberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_BTlistArchived"
                    )}
                    onClick={() => {
                        setIsArchivedPaymentMethodsClicked(true);
                    }}
                >
                    {t("Archived payment methods")}({shopsNumberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item pl-1 cmn_btn_BThistory",
                        {
                            "not-allowed-icon__clz":
                                selectedRows.length === 0 ||
                                isLoading ||
                                getArrayOfRows(selectedRows).length === 0,
                        }
                    )}`}
                    onClick={() => {
                        setIsHistoryShopsModalOpened(
                            !isHistoryShopsModalOpened
                        );
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true ? (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames("dropdown-item pl-1", {
                                "not-allowed-icon__clz": shouldDisableAction(
                                    isLoading,
                                    selectedRows,
                                    isArchivedPaymentMethodsClicked,
                                    listFranchiseArchived
                                ),
                            })}`}
                            onClick={async () => {
                                setIsLoading(true);
                                let isArchived = await checkIfSaleSupportIsArchived(
                                    userID,
                                    franchiseID,
                                    uuidUser as string,
                                    selectedRows,
                                    i18nextLng,
                                    t,
                                    fetchGlobal
                                );
                                if (
                                    selectedRows.length === 1 &&
                                    (selectedRows[0].subRows === undefined ||
                                        selectedRows[0].subRows.length < 2)
                                ) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                    setIsLoading(false);
                                } else if (
                                    isArchived === true &&
                                    isArchivedPaymentMethodsClicked
                                ) {
                                    ErrorToast(
                                        `${t(
                                            "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                        )!}`
                                    );
                                    setIsLoading(false);
                                } else if (!isArchivedPaymentMethodsClicked) {
                                    setIsArchivedValidationModalOpened(true);
                                    setIsActive(true);
                                    setIsLoading(false);
                                } else {
                                    handleArchivePaymentMethod(
                                        itemsDisable,
                                        { userID, franchiseID, operatorID },
                                        isActive,
                                        selectedRows,
                                        setIsValidateClicked,
                                        fetchGlobal
                                    );
                                    setIsActive(false);
                                }
                            }}
                        >
                            <span
                                className={classnames(
                                    "cmn_btn_BTarchived cmn_btn_BTunarchive",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                            >
                                {isArchivedPaymentMethodsClicked
                                    ? t("Unarchive")
                                    : t("Archive")}
                            </span>
                        </div>
                    </>
                ) : null}
            </div>
            {isArchivedValidationModalOpened ? (
                <ArchivedValidationModal
                    text={t(
                        "Attention, this (these) payment method can be used by other modules.\n\nDo you want to confirm the archiving of the selected of payment method(s)"
                    )}
                    isModalOpened={isArchivedValidationModalOpened}
                    setIsModalOpened={setIsArchivedValidationModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </div>
    );
}
